export default "__VITE_ASSET__CJMeJxI4__"